export const routeIds = {
  home: 'home',
  aboutUs: 'about-us',
  team: 'team',
  articlesAndVideos: 'articles-and-videos',
  community: 'community',
  getInTouch: 'get-in-touch',
}
